import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo } from "@/lib/seo";

const GA_ID = "AW-17489509584";
const GA4_ID = "G-W4WES1Z8J4";

/**
 * Fires a gtag page_view on every React Router location change.
 * Required for SPAs so Google Ads sees every "virtual" page navigation,
 * not just the initial load.
 */
export const RouteTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    applySeo(pathname);
    if (typeof window.gtag !== "function") return;
    const page_path = pathname + (search || "");
    window.gtag("config", GA_ID, {
      page_path,
      page_title: document.title,
      page_location: window.location.href,
      allow_enhanced_conversions: true,
    });
    window.gtag("config", GA4_ID, {
      page_path,
      page_title: document.title,
      page_location: window.location.href,
    });
    window.gtag("event", "page_view", {
      page_path,
      page_title: document.title,
      page_location: window.location.href,
      send_to: GA_ID,
    });
  }, [pathname, search]);

  return null;
};
